import React, {Fragment} from 'react'
import CommonCounter from './CommonCounter'
import { getCodamYearsSinceFounding } from '../../constants/codamHistoryData'

const counterContent = [
    { num:'150', desc:'기업 고객 구축 완료' },
    { num:'98', desc:'고객 재계약률 (%)' },
    { num: String(getCodamYearsSinceFounding()), desc:'엔터프라이즈 구축 경력 (년)' },
]

const CounterTwo = () => {
    return (
        <Fragment>
            <ul className="list-none count-list">
                {counterContent.map((val,i)=>(
                    <li key={i}>
                        <div className="counter-style-two boder-style d-xxl-flex align-items-center mb-30">
                            <h3><span className="counter"><CommonCounter value={val.num} /></span>+</h3>
                            <p className="text-white">{val.desc}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </Fragment>
    )
}

export default CounterTwo
